import React from 'react';
import { eventsStore, refsStore, datasetStore, videoStore } from '../managers/globalState';

import '../../www/assets/css/date_label.css';
import { cloneDate, formatDate, subtractDaysFromDate } from '../helpers/tools';

/**
 * @typedef Props
 * @prop {string} content
 */

// ToDo: rebuild as functional component to take advantage of useSnapshot.
class DateLabel extends React.Component {
	/**
	 * Constructs the component.
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		this.datasetDateSpanMap = {
			daily: 0,
			month: 30,
			ten_day: 9,
			seven_day: 6,
			eight_day: 7,
			three_day: 2,
			sixteen_day: 15
		};
    this._lang =  window.config && window.config.acceptLanguage && window.config.acceptLanguage == 'ar' ? 'ar-SA' : this._lang ;
	}

	componentDidMount() {
		this.eventsUnsubscribe = eventsStore.subscribeTo('showOnGlobe', () => this.forceUpdate());
		this.dsUnsubscribe = datasetStore.subscribeAll(() => this.forceUpdate());
	}

	componentWillUnmount() {
		typeof this.eventsUnsubscribe === 'function' && this.eventsUnsubscribe();
		typeof this.dsUnsubscribe === 'function' && this.dsUnsubscribe();
	}

	render() {
		const { event } = this.props;
		const { showOnGlobe: showEvent } = eventsStore.stateSnapshot;
		const { animationIndex } = datasetStore.stateSnapshot;

		const { get } = refsStore.stateSnapshot;
		const { videoId } = videoStore.stateSnapshot;

		const { dataset, animations, isVisibleEarth } = get('dataset');
		const { isSatellitesNow } = get('content');

		if (isSatellitesNow || !(dataset?.latestTileset) || animationIndex === -1) {
			return null;
		}

		const { average } = dataset;
		if (!isVisibleEarth && !animations.length) {
			return null;
		}

		if (event.id !== null && event.id !== undefined) {
			return null;
		}

		if (videoId) {
			const videoManager = get('video');
			const videoType = videoManager.getVideoType(videoId);

			if (videoType === 'global' || videoType === 'geoLocated') {
				return null;
			}
		}


		// Dates are stored in UTC ISO format but we want to display them to users in their own timezone.
		// The formatDate tool helper does this for us.
		const dateSource = animations?.[animationIndex] ?? dataset.latestTileset;
		const { dateObject: endDateObj } = dateSource;

		const endDate = cloneDate(endDateObj);

		/**
		 * Use the spread operator inside the object to conditionally add the day: undefined.
		 * https://www.codemzy.com/blog/conditionally-add-property-to-object-javascript
		*/

		const endDateStr = formatDate(endDate, {
			month: 'long',
			...average === 'month' && { day: undefined }
		});

		const daysBack = this.datasetDateSpanMap[average];
    // const msBack = daysBack * 24 * 60 * 60 * 1000;
		// const beginDate = new Date(endDate - msBack);
		// let beginDateString = '';

		// if (average !== 'daily' && average !== 'month') {
		// 	beginDateString = beginDate.toLocaleString(this._lang, { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' }) + ' -';
		// 	endDateString = endDate.toLocaleString(this._lang, { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' });
		// } else if (average === 'daily') {
		// 	endDateString = endDate.toLocaleString(this._lang, { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' });
		// } else if (average === 'month') {
		// 	endDateString = endDate.toLocaleString(this._lang, { timeZone: 'UTC', month: 'long', year: 'numeric' });
		// }

    
    const showRange = average !== 'daily' && average !== 'month';

		let beginDateStr = '';
		if (showRange) {
			const beginDate = subtractDaysFromDate(cloneDate(endDate), daysBack);
			beginDateStr = formatDate(beginDate, { month: 'long' });
		}


		const dateText = `${beginDateStr}${beginDateStr ? ' - ' : ''}${endDateStr}`;

		return (
			<>
				<div id='date-label' className='date-label d-none d-lg-flex flex-lg-column'>
					<span className='date-text outline'>{dateText}</span>
				</div>
				{!showEvent && (
					<div id='mobile-date-label' className='d-block d-lg-none'>
						<span className='date-text outline'>{dateText}</span>
					</div>
				)}
			</>
		);
	}
}

export default DateLabel;
